import { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './auth-provider';
import { translate } from '../firebase/errors';
import * as Sentry from "@sentry/react";

function SignupPage() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({name: '', email: '', password: '', confirmPassword: ''});
  const [error, setError] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup(formData);
      const origin = location.state?.from?.pathname || '/dashboard';
      navigate(origin);
      }
    catch (e) {
      const { code } = e;
      const message = code ? translate(code) : e.message;
      setError(message || `An error has occurred: ${code}`);
      if (!message) {
        Sentry.captureException(e);
      }
    }
  }
  return (
    <section className="section">
      <div className="container has-text-centered">
        <div className="column is-4 is-offset-4">
          <h3 className="title">Sign Up</h3>
          <div className="block has-text-grey-lighter">
            <i className="fa-solid fa-circle-user fa-6x"></i>
          </div>
          {error && <div className="notification is-danger is-light">{error}</div>}
          <div className="box">
            <form onSubmit={handleSubmit} noValidate>
              <div className="field">
                <div className="control has-icons-left">
                  <input className="input" type="text" name="name" value={formData.name} placeholder="Name" autoFocus onChange={handleChange}/>
                  <span className="icon is-small is-left">
                    <i className="fa-solid fa-user"></i>
                  </span>
                </div>
              </div>
              <div className="field">
                <div className="control has-icons-left">
                  <input className="input" type="email" name="email" value={formData.email} placeholder="Email" onChange={handleChange}/>
                  <span className="icon is-small is-left">
                    <i className="fa-solid fa-envelope"></i>
                  </span>
                </div>
              </div>
              <div className="field">
                <div className="control has-icons-left">
                  <input className="input" type="password" name="password" value={formData.password} placeholder="Password" onChange={handleChange}/>
                  <span className="icon is-small is-left">
                    <i className="fa-solid fa-lock"></i>
                  </span>
                </div>
              </div>
              <div className="field">
                <div className="control has-icons-left">
                  <input className="input" type="password" name="confirmPassword" value={formData.confirmPassword} placeholder="Confirm Password" onChange={handleChange}/>
                  <span className="icon is-small is-left">
                    <i className="fa-solid fa-lock"></i>
                  </span>
                </div>
              </div>
              <button className="button is-primary is-fullwidth">Sign Up</button>
            </form>
          </div>
          <p>
            <NavLink to="/login">Log in</NavLink>
            &nbsp;·&nbsp;
            <NavLink to="/forgot-password">Forgot password?</NavLink>
          </p>
        </div>
      </div>
    </section>
  );
}

export default SignupPage;
